<template>
  <l-map
    :zoom="zoom"
    :center="center"
    :options="mapOptions"
    ref="singleSchoolMap"
  >
    <l-control position="topleft">
      <v-flex  class="school-map-address">
        <v-icon>place</v-icon> {{ singleSchool.address }}
        {{ singleSchool.icon }}
      </v-flex>
    </l-control>
    <l-tile-layer
      :url="url"
      :attribution="attribution"
    />
    <l-marker :lat-lng="singleSchool.coords" :icon="icon"/>
    <l-control position="bottomleft">
      <v-flex xs12 class="school-map-legend">
        <span class="school-map-legend-title">{{ $t('Score out of 10') }}</span>
        <v-layout row wrap justify-center align-center class="layout-wrapper">
          <v-flex xs3 class="box school-map-legend-red">
            <div class="school-map-legend-label">
            0 - 4
            </div>
          </v-flex>
          <v-flex xs3 class="box school-map-legend-orange">
            <div class="school-map-legend-label">
            4.1 - 5.9
            </div>
          </v-flex>
          <v-flex xs3 class="box school-map-legend-yellow">
            <div class="school-map-legend-label">
            6 - 7.5
            </div>
          </v-flex>
          <v-flex xs3 class="box school-map-legend-green">
            <div class="school-map-legend-label">
            7.6 - 10
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </l-control>
  </l-map>
</template>

<script>
  import { LMap, LTileLayer, LMarker, LControl } from 'vue2-leaflet';
  import L from 'leaflet';
    export default {
      name: 'SchoolPageMap',
      props: ['singleSchool', 'iconUrl'],
      components: {
        LMap,
        LTileLayer,
        LMarker,
        LControl
      },
      data() {
        return {
          zoom: 13,
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          currentZoom: 11.5,
          mapOptions: {
            zoomControl: false,
          },
          icon: null,
        }
      },
      mounted() {
        this.$nextTick(() => {
          this.singleSchoolMap = this.$refs.singleSchoolMap.mapObject;
          L.tileLayer.provider('CartoDB.Voyager').addTo(this.singleSchoolMap);

          this.icon = L.icon({
            iconUrl: require("@/assets/images/" + this.iconUrl),
            iconSize: [40, 40],
            iconAnchor: [20, 0]
          });
        });
      },
      computed: {
        center: {
          get() {
            return L.latLng(this.singleSchool.coords.lat, this.singleSchool.coords.lon);
            }
          }
        },
    }


</script>
